module.exports = "/images/vendor/flag-icon-css/flags/1x1/ee.svg?9e932a62565e7ddda05182b706b4e48f";